<template>
  <div class="ac-page">
    <div class="ac-title">
      <img src="../../assets/images/rules.png">
    </div>
    <!-- 活动规则 -->
    <div class="ac-rules">
      <ul class="tab-title">
        <li @click="current = 0" :class="{active: !current}">激活率PK<span>ROUND1</span></li>
        <li @click="current = 1" :class="{active: current === 1}">激活率PK<span>ROUND2</span></li>
        <li @click="current = 2" :class="{active: current === 2}" style="line-height: 35px">扫码率PK</li>
      </ul>
      <div class="tab-content">
        <div class="tab-content-row">
          <label>
            <img src="../../assets/images/pointer.png" class="pointer">
            <span>活动时间：</span>
          </label>
          <span v-if="!current">2019年7月1日 – 8月14日</span>
          <span v-else-if="current === 1">2019年8月15日 – 9月30日</span>
          <span v-else>2019年10月 – 12月（每月一轮，共三轮）</span>
        </div>
        <div class="tab-content-row">
          <label>
            <img src="../../assets/images/pointer.png" class="pointer">
            <span>参与战队：</span>
          </label>
          <span v-if="!current">上海、苏州、深圳、成都</span>
          <span v-else-if="current === 1">北京、广州（包括佛山）、西安、杭州、石家庄</span>
          <span v-else>所有城市</span>
        </div>
        <div class="tab-content-row">
          <label>
            <img src="../../assets/images/pointer.png" class="pointer">
            <span>参与对象：</span>
          </label>
          <span>城市战队所有易加网修理厂会员</span>
        </div>
        <div class="tab-content-row">
          <label class="content-item">
            <img src="../../assets/images/pointer.png" class="pointer">
            <span v-if="current === 2">获胜条件：10月至12月以城市战队为统计对象，当月扫码率最高的城市战队胜出</span>
            <span v-else>获胜条件：城市战队易加修理厂会员激活率最高的城市获胜</span>
          </label>
        </div>
        <div class="tab-content-row">
          <label class="content-item">
            <img src="../../assets/images/pointer.png" class="pointer">
            <span v-if="current === 2">获胜奖励：获胜城市参加扫码的易加修理厂会员，按照获胜当月扫码量瓜分3百万易加积分</span>
          <span v-else>获胜奖励：获胜城市参加扫码的易加修理厂会员，在PK时间段内的积分翻倍</span>
          </label>
        </div>
      </div>
    </div>

    <div style="margin-top: 40px;" v-for="(item, index) in battleDataList" :key="index">
      <activity-box :pkData='item'></activity-box>
    </div>

    <div class="return-btn" @click="returnToHome">
      <img src="../../assets/images/return.png">
    </div>

  </div>
</template>

<script>
import activityApi from '@/api/activity'
import activityBox from './components/activity-pk-box'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
export default {
  data () {
    return {
      current: 2,
      userInfo: [],
      battleDataList: []
    }
  },
  components: {
    'activity-box': activityBox
  },
  created () {
    this.userInfo = userUtils.getClientInfo()
    if (!this.userInfo) {
      window.location.href = commonUtils.getExtraSite() + '/#/login'
    }
    if (this.userInfo) {
      this.getBattleList()
    }
  },
  methods: {
    getBattleList () {
      activityApi.getBattleList().then(res => {
        if (res.data.resultCode === '0') {
          this.battleDataList = res.data.resultData.battleDataList
        }
      })
    },
    returnToHome () {
      window.location.href = commonUtils.getExtraSite()
    }
  }
}
</script>

<style lang="less" scoped>
.ac-page {
  padding: 215px 10px 20px 10px;
  background: #2e5099 url("../../assets/images/bg.png") no-repeat;
  background-size: 100% auto;
}
img {
  width: 100%;
  height: 100%;
}
.ac-title {
  width: 84px;
  height: 19px;
  margin: auto;
}
.ac-rules {
  width: 100%;
  height: 210px;
  border-radius: 5px;
  background-color: #fff;
  opacity: 0.8;
  margin: 10px auto;
  box-sizing: border-box;
  overflow: hidden;
  .tab-title {
    height: 40px;
    width: 225px;
    display: flex;
    overflow: hidden;
    border-bottom-right-radius: 15px;
    li {
      width: 75px;
      height: 40px;
      color: #4b77ba;
      font-size: 14px;
      font-weight: bold;
      background-color: #c3cfe6;
      text-align: center;
      padding-top: 4px;
      outline: 1px solid #4b77ba;
      span {
        display: inline-block;
        font-size: 12px
      }
    }
  }
}
.tab-content {
  padding: 10px;
  font-size: 12px;
  color: #1f2135;
  box-sizing: border-box;
}
.tab-content-row > label > span {
  padding-left: 8px;
  line-height: 20px;
}
.support-text div {
  padding-left: 12px;
  line-height: 18px;
}
.pointer {
  width: 6px;
  height: 6px;
}
.active {
  color: #fff !important;
  background-color: #4b77ba !important;
}
.return-btn {
  width: 150px;
  height: 45px;
  margin: 25px auto 0 ;
  border-radius: 5px;
  overflow: hidden;
}
.content-item {
  display: flex;
  img {
    margin-top: 8px;
  }
}
</style>
